import { Injectable } from "@angular/core";
import { LocalStorage } from "@ngx-pwa/local-storage";
import { Observable } from "rxjs";


@Injectable({ providedIn: 'root' })
export class StorageService{

    constructor(public storage: LocalStorage) {}

    setValue(key: string, value: any) {
        return this.storage.setItem(key, value);
      }
    
      getValue(key: string) : Observable<any> {
        return this.storage.getItem(key);
      }
    
      removeKey(key: string) {
        return this.storage.removeItem(key);
      }
    
      removeAll() {
        return this.storage.clear().subscribe((res) => { 
          return res;
        });
      }
}